import { useEffect } from "react";

const usePersistentScroll = (ref: React.RefObject<HTMLElement>, key: string) => {
    useEffect(() => {
        const scrollable = ref.current;
        const savedScrollTop = parseInt(sessionStorage.getItem(key) || "0", 10);
        if (scrollable && savedScrollTop > 0) {
            scrollable.scrollTo({ top: savedScrollTop, behavior: "smooth" });
            sessionStorage.removeItem(key);
        }
    }, [ref, key]);

    const storeScroll = () => {
        sessionStorage.setItem(key, String(ref.current?.scrollTop || 0));
    };

    return { storeScroll };
}

export default usePersistentScroll;
